import normalize from 'json-api-normalizer';

export default class Signup {

    constructor ({ firstName, lastName, provinceId, clientSourceId, email, password, passwordConfirmation, lang, therapistAssistant, courseInterestsId }) {

        this.first_name             = firstName ? firstName : null;
        this.last_name              = lastName ? lastName : null;
        this.province_id            = provinceId ? provinceId : null;
        this.client_source_id         = clientSourceId ? clientSourceId : null;
        this.email                  = email ? email : null;
        this.email_confirmation     = null;
        this.password               = password ? password : null;
        this.password_confirmation  = passwordConfirmation ? passwordConfirmation : null;
        this.lang                   = lang ? lang : 'en';
        this.therapist_assistant   = therapistAssistant ? therapistAssistant : (therapistAssistant == false && therapistAssistant != '') ? false : '';
        this.course_interests_id = courseInterestsId ? courseInterestsId : null;
	}

    toJSONapi () {

        let attributes = Object.assign({}, this);

        attributes.email = attributes.email.toLowerCase().trim();
        attributes.email_confirmation = attributes.email_confirmation.toLowerCase().trim();

        return { user:  attributes };

    }

}
